import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="delivery-form"
export default class extends Controller {
  static outlets = ['phone-number-input', 'places']
  static targets = ['email', 'address2']

  handleClientPick(event) {
    const { phone, email, location, address2 } = event.detail

    if (!phone) return

    this.phoneNumberInputOutlet.setRawValue(phone)
    this.emailTarget.value = email
    this.placesOutlet.populate(location?.address?.place_id)
    this.address2Target.value = address2
  }
}
